import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useFormik } from "formik";
import CreateLoginForm from "@serie3/common/Form/Login/CreateLoginForm";
import HeroImage from "../../../assets/images/landingpage/heroImage.png";
import Brand from "../../shared/Brand";

const Login = ({ setToken }) => {
  const { t } = useTranslation();
  const [showLoginError, setShowLoginError] = useState(false);

  const loginForm = CreateLoginForm(setToken, setShowLoginError, () => {});
  const formik = useFormik(loginForm);

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>

      {/* ── Left branding panel ── */}
      <div className="auth-branding-panel" style={{
        flex: "0 0 45%",
        background: "linear-gradient(180deg, rgba(255,255,255,0.00) 14.92%, rgba(255,184,0,0.16) 100%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "48px 56px",
        position: "relative",
        overflow: "hidden",
      }}>
        {/* decorative blobs */}
        <div style={{
          position: "absolute", top: -100, right: -100,
          width: 400, height: 400, borderRadius: "50%",
          background: "radial-gradient(circle, rgba(255,184,0,0.15) 0%, transparent 70%)",
          pointerEvents: "none",
        }} />
        <div style={{
          position: "absolute", bottom: -80, left: -80,
          width: 300, height: 300, borderRadius: "50%",
          background: "radial-gradient(circle, rgba(243,78,78,0.08) 0%, transparent 70%)",
          pointerEvents: "none",
        }} />

        {/* logo / wordmark */}
        <div style={{ zIndex: 1, marginBottom: 48 }}>
          <Brand />
        </div>

        {/* centre copy */}
        <div style={{ zIndex: 1 }}>
          <h2 style={{
            color: "#111827", fontFamily: "Montserrat,sans-serif",
            fontSize: 36, fontWeight: 800, lineHeight: "46px",
            letterSpacing: "-1px", marginBottom: 16,
          }}>
            {t("Landingpage.HeroHeader")}
          </h2>
          <p style={{ color: "#4b5563", fontSize: 16, lineHeight: "26px", fontFamily: "Montserrat,sans-serif", marginBottom: 40 }}>
            {t("Landingpage.HeroText")}
          </p>
          <img
            src={HeroImage}
            alt=""
            style={{ width: "100%", borderRadius: 16, boxShadow: "0 20px 60px rgba(0,0,0,0.12)" }}
          />
        </div>

        <p style={{ color: "#9299a8", fontSize: 13, fontFamily: "Montserrat,sans-serif", zIndex: 1, marginBottom: 0 }}>
          © 2025 MyMediaPlanner
        </p>
      </div>

      {/* ── Right form panel ── */}
      <div style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8fafc",
        padding: "48px 40px",
      }}>
        <div style={{ width: "100%", maxWidth: 420 }}>
          <h3 style={{
            fontFamily: "Montserrat,sans-serif", fontWeight: 800,
            fontSize: 28, color: "#111827", marginBottom: 6,
          }}>
            {t("Login.Title")}
          </h3>
          <p style={{ color: "#6b7280", fontSize: 15, marginBottom: 32 }}>
            {t("Login.Subtitle")}
          </p>

          <Form onSubmit={formik.handleSubmit}>
            <div style={{ marginBottom: 20 }}>
              <Form.Label htmlFor="input-username" style={{ fontWeight: 600, fontSize: 13, color: "#374151", marginBottom: 6, display: "block" }}>
                {t("Login.Email")}
              </Form.Label>
              <Form.Control
                id="input-username"
                type="text"
                name="username"
                value={formik.values.username}
                onChange={formik.handleChange}
                isInvalid={!!formik.errors.username}
                style={{ borderRadius: 10, border: "1.5px solid #e2e5ea", padding: "12px 14px", fontSize: 14 }}
              />
            </div>

            <div style={{ marginBottom: 28 }}>
              <Form.Label htmlFor="input-password" style={{ fontWeight: 600, fontSize: 13, color: "#374151", marginBottom: 6, display: "block" }}>
                {t("Login.Password")}
              </Form.Label>
              <Form.Control
                id="input-password"
                type="password"
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                isInvalid={!!formik.errors.password}
                style={{ borderRadius: 10, border: "1.5px solid #e2e5ea", padding: "12px 14px", fontSize: 14 }}
              />
            </div>

            <button
              type="submit"
              onClick={() => setShowLoginError(false)}
              style={{
                width: "100%", padding: "14px", borderRadius: 50,
                background: "linear-gradient(135deg,#f34e4e,#e03030)",
                border: "none", color: "#fff",
                fontFamily: "Montserrat,sans-serif", fontWeight: 700, fontSize: 16,
                cursor: "pointer", boxShadow: "0 6px 20px rgba(243,78,78,0.35)",
                transition: "transform 0.15s ease, box-shadow 0.15s ease",
              }}
            >
              {t("Login.SignInButton")}
            </button>
          </Form>

          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 28 }}>
            <Link to="/resetpassword" style={{ color: "#6b7280", fontSize: 14, textDecoration: "none" }}>
              {t("Login.ForgotLink")}
            </Link>
            <Link to="/signup" style={{ color: "#038edc", fontSize: 14, fontWeight: 600, textDecoration: "none" }}>
              {t("Login.New Account")} →
            </Link>
          </div>

          <div style={{ marginTop: 24, textAlign: "center", minHeight: 24 }}>
            {showLoginError && <span style={{ color: "#f34e4e", fontSize: 14 }}>{t("Login.Messages.Error")}</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
